import useBreakpoints, { Breakpoint } from "../../../hooks/useBreakpoints";

/**
 * The rule closing an ExerciseCard's head against what follows. The design draws it to both card
 * edges, unlike the inset separators between answers, so it reaches back past the card's own
 * padding — which is why it lives beside ExerciseCard rather than with its callers: the -mx-* here
 * has to track the p-m / p-s there.
 *
 * mt-xs sets it 24px below the head instead of the card's own 16px gap. Below the line it adds
 * nothing, so the card's gap keeps what follows off the rule — the design closes that gap and lets
 * the answer rows' own padding carry it, which only works once those rows are drawn (HALLOFUSS-6675).
 */
const ExerciseCardDivider = () => {
    const { getStyleBasedOnBreakpoint } = useBreakpoints();

    return (
        <div
            className={`border-b border-p6-grey-light mt-xs ${getStyleBasedOnBreakpoint(
                Breakpoint.MD,
                "-mx-m",
                "-mx-s"
            )}`}
            aria-hidden="true"
        />
    );
};

export default ExerciseCardDivider;
